import DashboardViewSwitch from './DashboardViewSwitch';

export default DashboardViewSwitch;
